//
import React, { Component } from 'react';
import { Row, Col, Icon, Button, Input, Divider, message, Table, Modal, DatePicker, Select } from 'antd';
import { connect } from 'react-redux';
import { getCookie } from './../../hook';
import Papa from 'papaparse';

import currency from './../../currency';

// Actions
import { 
    save_expense, 
    get_users, 
    get_expense,
    delete_expense,
    update_expense } from './actions/expense.action';

// Child
import NewExpense from './childs/new.expense';

// style
import './style.css';
import moment from 'moment';

let timer,x;
const Option = Select.Option;
const confirm = Modal.confirm;
const dateFormat = 'YYYY/MM/DD';
class Expense extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            visible: false,
            users_list: []
        }

        this.handleNewExpense = this.handleNewExpense.bind( this );
        this.handleCancelModule = this.handleCancelModule.bind( this );
        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleDeleteExpense = this.handleDeleteExpense.bind( this );
        this.handleFieldsExpense = this.handleFieldsExpense.bind( this );
        this.handleDownload = this.handleDownload.bind( this );

    }

    handleDownload(){
        
        let tempData = this.state.data;

        if( tempData ){

            let final_data = [];

            tempData.map( ( item, i ) => {
                let stack = {
                    'Employee': item.full_name,
                    'Date': item.exp_date,
                    'Description': item.exp_description,
                    'Amount': item.exp_amount,
                    'Currency': item.exp_currency,
                    'Currency Rate': item.exp_currency_rate,
                    'Amount AED': item.amount_aed
                }

                final_data.push( stack );

            });

            let csvData = Papa.unparse( final_data );
            let filename = 'Expense.csv';

            var link = window.document.createElement("a");
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvData));
            link.setAttribute("download", filename );
            link.click();

        }

    }

    handleFieldsExpense( id, key, value ){

        let self = this;
        clearTimeout(timer);
        timer = setTimeout(() => {
            self.props.update_expense( id, key, value );
        }, 700);

    }

    handleDeleteExpense( expense_id ){
                
        let self = this;
        
        confirm({
            title: 'Do you want to delete this expense?',
            onOk() {
                self.props.delete_expense( expense_id );
            },
            onCancel() {
                // Nothing
            },
        });
        
    }

    handleSubmit( data ){
        this.props.save_expense( data );
    }

    handleCancelModule(){
        this.setState({ visible: false });
    }

    handleNewExpense(){
        this.setState({ visible: true });
    }

    componentWillMount(){
        const user = getCookie('dv_hrms_user').split(',');
        this.props.get_users();
        this.props.get_expense( user[6] );
    }

    componentWillReceiveProps( nextProps ){
        if( nextProps.expense.length !== 0 ){
            if( nextProps.expense ){
                if( nextProps.expense.STATUS.CODE === "200" &&
                    nextProps.expense.STATUS.MESSAGE === "Successfully Saved" ){
                    const user = getCookie('dv_hrms_user').split(',');
                    message.success( nextProps.expense.STATUS.MESSAGE );
                    this.setState({ visible: false });
                    this.props.get_expense( user[6] );
                }

                if( nextProps.expense.STATUS.CODE === "200" &&
                    nextProps.expense.STATUS.MESSAGE === "Successfully Listed Users" ){
                    this.setState({ users_list: nextProps.expense.OUTPUT.DATA });
                }

                if( nextProps.expense.STATUS.CODE === "200" &&
                    nextProps.expense.STATUS.MESSAGE === "Successfully Listed Expenses" ){
                    this.setState({ data: nextProps.expense.OUTPUT.DATA });
                }

                if( nextProps.expense.STATUS.CODE === "201" &&
                    nextProps.expense.STATUS.MESSAGE === "Successfully Deleted Expense" ){
                    const user = getCookie('dv_hrms_user').split(',');
                    message.success( "Successfully Deleted" );
                    this.setState({ visible: false });
                    this.props.get_expense( user[6] );
                }

                if( nextProps.expense.STATUS.CODE === "201" &&
                    nextProps.expense.STATUS.MESSAGE === "Successfully Updated Expenses" ){
                    const user = getCookie('dv_hrms_user').split(',');
                    message.success( "Successfully Updated" );
                    this.setState({ visible: false });
                    this.props.get_expense( user[6] );
                }

            }
        }
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => 
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                } 
            }
            
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    render() {

        const currency_list = currency.map( (item, k ) => <Option value={ item }>{ item }</Option> );

        const column = [
            {
                title: 'Employee',
                dataIndex: 'full_name',
                key: 'full_name',
                width: '12.5%',
                ...this.getColumnSearchProps( 'full_name' )
            },{
                title: 'Date',
                key: 'exp_date',
                width: '12.5%',
                render: ( record ) => <DatePicker 
                onChange={ (date, dateString ) => this.handleFieldsExpense( record.expense_id, 'exp_date', dateString ) }
                defaultValue={ moment( record.exp_date, dateFormat ) } />
            },{
                title: 'Description',
                key: 'exp_description',
                width: '12.5%',
                render: ( record ) => <Input 
                onChange={ (e)=> this.handleFieldsExpense( record.expense_id, 'exp_description', e.target.value ) }
                defaultValue={ record.exp_description } />,
                ...this.getColumnSearchProps( 'exp_description' )
            },{
                title: 'Amount',
                key: 'exp_amount',
                width: '12.5%',
                render: ( record ) => <Input 
                onChange={ (e)=> this.handleFieldsExpense( record.expense_id, 'exp_amount', e.target.value ) }
                defaultValue={ record.exp_amount } />
            },{
                title: 'Currency',
                key: 'exp_currency',
                width: '12.5%',
                render: ( record ) => <Select
                    showSearch
                    onChange={ ( value ) => this.handleFieldsExpense( record.expense_id, 'exp_currency', value ) } 
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    defaultValue={ record.exp_currency }  
                    style={{ width: '100%' }}>
                    { currency_list }
                </Select>
            },{
                title: 'Currency Rate',
                key: 'exp_currency_rate',
                width: '12.5%',
                render: ( record ) => <Input 
                onChange={ (e)=> this.handleFieldsExpense( record.expense_id, 'exp_currency_rate', e.target.value ) }
                defaultValue={ record.exp_currency_rate } />
            },{
                title: 'Amount AED',
                dataIndex: 'amount_aed',
                key: 'amount_aed',
                width: '12.5%',
            },{
                title: 'Actions',
                key: 'actions',
                width: '12.5%',
                render: ( record ) => <Button 
                onClick={ ()=> this.handleDeleteExpense( record.expense_id ) }
                icon="delete" type="danger" />
            }
        ]

        return (
            <div className="expense_wrapper">

                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="dollar" />
                            &nbsp; Expense Reimbursement
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            style={{ marginLeft: '10px' }}
                            onClick={ this.handleDownload }
                            className="fl_right" icon="download">Download</Button>
                        <Button
                            onClick={ this.handleNewExpense }
                            className="fl_right" type="primary" icon="plus">Add Expense</Button>
                    </Col>
                </Row>

                <Divider />

                <Row>
                    <Col span={24}>
                        <Table columns={ column } dataSource={ this.state.data } />
                    </Col>
                </Row>

                {/* Add new Expense */}
                <NewExpense 
                    onVisible={ this.state.visible } 
                    onCancel={ this.handleCancelModule }
                    onSubmit={ this.handleSubmit }
                    users={ this.state.users_list } />
                
            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        expense: state.expense
    }
}

export default connect( mapStatetoProps, { 
    save_expense, 
    get_users,
    get_expense,
    delete_expense,
    update_expense } )( Expense );




// WEBPACK FOOTER //
// ./src/pages/expense/index.js